"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _MediaNodeStore = _interopRequireDefault(require("./MediaNodeStore"));

var _MediaStore = _interopRequireDefault(require("./MediaStore"));

var _QueryStore = _interopRequireDefault(require("./QueryStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Store = function Store() {
  var mediaNodeStore = (0, _MediaNodeStore["default"])();
  var queryStore = (0, _QueryStore["default"])();
  var mediaStore = (0, _MediaStore["default"])(mediaNodeStore.$);
  var $ = (0, _rxjs.combineLatest)(queryStore.$, mediaStore.$).pipe((0, _operators.map)(function (_ref) {
    var queryState = _ref[0],
        mediaState = _ref[1];
    return {
      media: mediaState,
      query: queryState
    };
  }), (0, _operators.shareReplay)(1));
  return {
    $: $,
    destroy: function destroy() {
      queryStore.destroy();
      mediaNodeStore.destroy();
      mediaStore.destroy();
      if (_.isFunction(_.get($, 'complete'))) $.complete();
    },
    actions: _extends({}, queryStore.actions, mediaNodeStore.actions, mediaStore.actions)
  };
};

var _default = Store;
exports["default"] = _default;